import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { useDispatch, useSelector } from "react-redux";
import { accountBlockUser, accountUnBlockUser, getBlockUserList } from "../../redux/ApiSlice/BlockSlice";
import { IoMdArrowBack } from "react-icons/io";

const BlockedUser = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector((state) => state.blockedUsers);
    const [loadingUserId, setLoadingUserId] = useState(null);

    useEffect(() => {
        dispatch(getBlockUserList());
    }, [dispatch]);

    const handleUnblock = async (id) => {
        setLoadingUserId(id);
        try {
            await dispatch(accountUnBlockUser(id));
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingUserId(null);
        }
    };

    const handleBlock = async (id) => {
        setLoadingUserId(id);
        try {
            await dispatch(accountBlockUser(id));
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingUserId(null);
        }
    };

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="text-[24px] text-black absolute top-1/2 left-2 transform -translate-y-1/2 cursor-pointer"
                    />
                    <p className="text-[16px] font-semibold text-black">
                        Blocked Users
                    </p>
                </div>
            </div>

            {loading &&
                <div className="flex justify-center items-center h-[70vh]">
                    <ClipLoader
                        size={40}
                        color={"#333333"}
                        loading={loading}
                    />
                </div>
            }

            {error &&
                <div className="flex justify-center items-center h-[70vh]">
                    <p className="text-[10px] text-red-500">Error: {error}</p>
                </div>
            }

            {!loading && !error && data.length === 0 && (
                <div className="flex justify-center items-center h-[69vh]">
                    <p className="text-[12px] text-gray-500">
                        You have no blocked users.
                    </p>
                </div>
            )}

            {data.map((user) => (
                <div key={user.id} className="p-2 items-center justify-center border-b border-gray-300 dark:border-gray-800/50 flex w-full">
                    <div className="h-10 w-14">
                        <img
                            alt={user.full_name}
                            src={user.avatar}
                            onClick={() => navigate(`/account/${user.id}`)}
                            className="h-10 w-10 rounded-full object-cover cursor-pointer border border-gray-300 dark:border-gray-800/50 bg-gray-100 dark:bg-[#333333]"
                        />
                    </div>
                    <div className="flex justify-between w-full">
                        <div className="flex flex-col justify-center mt-[2px]">
                            <p className="text-[13px] font-semibold line-clamp-1 cursor-pointer text-black dark:text-white">
                                {user.full_name}
                            </p>
                        </div>
                        <div className="flex items-start">
                            <button
                                onClick={() => user.is_blocked ? handleUnblock(user.id) : handleBlock(user.id)}
                                disabled={loadingUserId === user.id}
                                className="flex items-center gap-x-2 bg-blue-500 hover:bg-blue-600 disabled:opacity-60 text-white px-3 py-1 rounded-full text-[12px]"
                            >
                                {loadingUserId === user.id
                                    ? "Loading..."
                                    : user.is_blocked ? "Unblock" : "Block"}
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default BlockedUser;
